import AllhomesHeader from './allhomes-header';
export default AllhomesHeader;